export interface AppInfoType {
  app: string;
  icon: string;
  note?: string;
  erp: ERPType[];
  supportedPlatforms: SupportedType[];
  authentication: string[];
  supportedDevices?: DeviceType[];
}

export interface SupportedType {
  platform: PlatformType;
  minVersion: number | string | undefined;
  link?: string;
}

export interface DeviceType {
  brand: string;
  models: string[];
  installationNotes?: string[];
}

export enum ERPType {
  ergo = "ergo",
  radix = "radix",
}

export enum PlatformType {
  android = "android",
  iOS = "iOS",
  windows = "windows",
  web = "web",
}

export interface FilterType {
  erp: ERPType | undefined;
  platform: PlatformType | undefined;
}
